import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";

import styles from "./GameState.module.css";

function GameState() {
  const player = useAppSelector((state) => state.user.player);
  const game = useAppSelector((state) => state.game.game);
  const activeClass = player.turnToPlay ? styles.active : "";

  const { t } = useTranslation();

  return (
    <div className={`${styles.gameState} ${activeClass}`}>
      <div className="direction">
        <div className={styles.label}>{t("GameState.directionLabel")}</div>
        <div className="value">{t([`GameDirection.${game.direction}`])}</div>
      </div>
      <div className="active-player">
        <div className={styles.label}>{t("GameState.activePlayerLabel")}</div>
        <div className="value">{game.players[game.turn].name}</div>
      </div>
      {game.tempSuit && (
        <div className="temp-suite">
          <div className={styles.label}>{t("GameState.tempSuitLabel")}</div>
          <div
            className={styles.tempSuitValue}
            style={{ backgroundColor: game.tempSuit }}
          >
            {t([`SuitType.${game.tempSuit}`])}
          </div>
        </div>
      )}
    </div>
  );
}

export default GameState;
